import React, { useEffect } from "react";
import $, { isArray } from "jquery";
import "bootstrap-daterangepicker/daterangepicker.css"; // Import Date Range Picker CSS
import "bootstrap-daterangepicker"; // Import Date Range Picker JS
import ContentHeader from "../../../../Components/ContentHeader/ContentHeader";
import Form from "../../../../Components/Form/Form";

function CreateStateUi({
  formik,
  id,
  addNewCenField,
  handleCenChange,
  removeCenField,
  selectData,
  setRrbId,
  setSelectData,
  decodedToken,
  isCenError,
  toast,
}) {
  useEffect(() => {
    // Initialize select2 with Bootstrap theme
    $(".select2bs4").select2({
      theme: "bootstrap4",
    });
    // Handle change event and sync with Formik state
    $(".select2bs4").on("change", (e) => {
      const { name, value } = e.target;
      if (name === "rrb_id") {
        setRrbId(value); // Set selected rrbId
      }
      formik.setFieldValue(name, value); // Sync with Formik
    });

    // Cleanup on unmount
    return () => {
      $(".select2bs4").select2("destroy");
    };
  }, [formik]);
  return (
    <div className="content-wrapper" style={{ minHeight: "100vh" }}>
      {/* Content Header */}
      <ContentHeader
        title={id ? "Update State" : "Create State"}
        buttonName={""}
        buttonBoolean={false}
        pageName={id ? "Update State" : "Create State"}
        backButton={true}
      />
      {/* Main Content */}
      <Form formik={formik} toast={toast}>
        {/* Select Fields */}
        {decodedToken?.role === 3 || decodedToken?.role === 4 && (
          <div className="form-group" key={"rrb_id"}>
            <label htmlFor={"rrb_id"}>Select RRB</label>
            <div
              className={`${
                formik.errors["rrb_id"] && formik.touched["rrb_id"]
                  ? "border-color-red"
                  : ""
              }`}
            >
              <select
                id="rrb_id"
                name="rrb_id"
                className="form-control w-100 p-2 select_css select2bs4"
                {...formik.getFieldProps("rrb_id")}
              >
                <option value="">Select RRB</option>
                {selectData?.rrb?.map((val) => {
                  const id = val?.id;
                  return <option value={id}>{val.name}</option>;
                })}
              </select>
            </div>
            {formik.errors["rrb_id"] && formik.touched["rrb_id"] && (
              <div className="select-error">{formik.errors["rrb_id"]}</div>
            )}
          </div>
        )}

        {/* Dynamic CEN Input Fields */}
        <div className="form-group">
          <label htmlFor="states">State:</label>
          <div>
            {formik?.values?.states?.map((cen, index) => (
              <div key={index}>
                <div className="d-flex align-items-center mb-2">
                  <input
                    type="text"
                    name={`states[${index}]`}
                    value={cen}
                    placeholder="Enter State"
                    className="form-control mr-2"
                    onChange={(e) => handleCenChange(index, e.target.value)}
                    onInput={(e) => {
                      const value = e.target.value;
                      e.target.value = value.slice(0, 25); // Limit to 10 digits
                    }}
                  />
                  {/* {!id && (
                                <>
                                  {formik?.values?.cens?.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      onClick={() => removeCenField(index)}
                                    >
                                      -
                                    </button>
                                  )}
                                  <button
                                    type="button"
                                    className="btn btn-success ml-2"
                                    onClick={addNewCenField}
                                  >
                                    +{" "}
                                  </button>
                                </>
                              )} */}
                </div>
                {/* {formik.errors.cens && formik.touched.cens && ((isArray(formik.errors?.cens) && index in formik.errors?.cens) || (!isArray(formik.errors?.cens) && formik.errors?.cens))&& (
                                <div className="select-error">{isArray(formik.errors?.cens) ? formik.errors?.cens[index] : formik.errors?.cens}</div>
                            )} */}
              </div>
            ))}
            <div className="select-error">{isCenError}</div>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default CreateStateUi;
